module.exports = __webpack_public_path__ + "img/blueRightArrow.972e65a2.svg";